export const useDefaultData = ({ Helpers }) => {

    const { getCurrentDate } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idgestion: '',
        fecha: getCurrentDate(),
        titulo: '',
        descripcion: '',
    }

    const defaultLogsForm = {
        idbitacora: '',
        idgestion: '',
        descripcion: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen,
        defaultLogsForm
    })
}